<script lang="ts">
	import { PanelRight } from 'lucide-svelte';
	import PanelLeft from 'lucide-svelte/icons/panel-left';

	import type { ComponentProps } from 'svelte';

	import { Button } from '$lib/components/ui/button';

	import { cn } from '$lib/utils';

	import { useSidebar } from './context.svelte';

	let {
		ref = $bindable(null),
		class: className,
		onclick,
		side = 'left',
		...restProps
	}: ComponentProps<typeof Button> & {
		onclick?: (e: MouseEvent) => void;
		side: 'left' | 'right';
	} = $props();

	const sidebar = useSidebar();

	const Icon = $derived(side === 'left' ? PanelLeft : PanelRight);
</script>

<Button
	type="button"
	onclick={(e) => {
		onclick?.(e);
		sidebar.toggle();
	}}
	data-sidebar="trigger"
	variant="ghost"
	size="icon"
	class={cn('h-7 w-7', className)}
	{...restProps}
>
	<Icon />
	<span class="sr-only">Toggle Sidebar</span>
</Button>
